import { Component } from '@angular/core';

@Component({
    selector: 'app-pageinaccessible',
    templateUrl: './pageinaccessible.component.html'
})
export class PageInaccessibleComponent {

    constructor() {
    }

}
